import React from 'react';
import { useSelector } from 'react-redux';

const Footer = () => {
    const {isAiOpen} = useSelector(state => state.data);

    return (
        <footer className='lm-footer' style={{width: isAiOpen ? "60%": "100%"}}>
            2025© Leadmerge.
        </footer>
    );
};

export default Footer;
